import { defaultParamList } from '@helpers/constant';
import React, { Fragment, useEffect, useState } from 'react';
import useAction from '../hooks/useAction';
import Filter from './filter';
import Table from './table';
import useActionTopics from "@pages/topics/hooks/useAction";

export default function (props: any) {
    const { data, getData, metaData, isLoader } = useAction();
    const { getData: getTopics, isLoader: isLoaderListTopic, data: dataListTopic } = useActionTopics();
    const [params, setParams]: any = useState(defaultParamList);
    useEffect(() => {
        fetchData();
        getTopics({ all: true });
    }, []);

    const fetchData = async (newParams?: any) => {
        const param = {
            ...params,
            ...newParams
        };

        Object.keys(param).forEach(key => param[key] === "" && delete param[key]);
        await setParams(param);
        getData(param);

    };

    const onSearch = (search: string) => {
        const param = Object.assign({ page: 1, search });
        fetchData(param)
    }

    const onChangeStatus = (status: string) => {
        const param = Object.assign({ page: 1, status });
        fetchData(param)
    }

    const onHandleTableChange = (pagination: any, filters: any, sorter: any) => {
        const { current, pageSize } = pagination;
        const sort = sorter.columnKey ? sorter.order : 'desc';
        const orderBy = sorter.columnKey ? sorter.columnKey : 'updatedAt';
        const param = {
            ...params,
            limit: pageSize,
            orderBy,
            page: pageSize == params.limit ? current : 1,
            sort: sort,
        };

        fetchData(param);
    }

    const onChangeDateRange = (dateRange: string) => {
        const param = Object.assign({ page: 1, publishDateTime: dateRange });
        fetchData(param)
    }

    const onChangeTopic = (topicId: string) => {
        const param = Object.assign({ page: 1, topicId });
        fetchData(param)
    }

    return (
        <Fragment>
            <Filter
                {...props}
                dataSource={data}
                onSearch={onSearch}
                onChangeStatus={onChangeStatus}
                onChangeDateRange={onChangeDateRange}
                onChangeTopic={onChangeTopic}
                isLoaderListTopic={isLoaderListTopic}
                dataListTopic={dataListTopic}
            />
            <Table
                {...props}
                fetchDataList={fetchData}
                loading={isLoader}
                dataSource={data}
                metaData={metaData}
                onTableChange={onHandleTableChange} />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/videos/libraries/index.tsx